{
  "version": 1,
  "asset_id": "14ad7af4-6662-4c3c-98e0-7491ea5d00d7",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/14ad7af4-6662-4c3c-98e0-7491ea5d00d7/loc-round-rock-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/14ad7af4-6662-4c3c-98e0-7491ea5d00d7/loc-round-rock-640.avif",
  "original_filename": "loc-round-rock-640.avif",
  "size": 22282,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:31Z"
}
